import { GET_ALL_CITIES_KMZ } from '../../../common/constants/constants';
import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';

export const getAllCities = async (network) => {
  try {
    const resp = await apiClient.get(GET_ALL_CITIES_KMZ(network), {});
    return resp.data;
  } catch (error) {
    handleApiError(error);
  }
};
